import { render, staticRenderFns } from "./SeperatorX.vue?vue&type=template&id=6f1ceaef"
import script from "./SeperatorX.vue?vue&type=script&lang=js"
export * from "./SeperatorX.vue?vue&type=script&lang=js"
import style0 from "./SeperatorX.vue?vue&type=style&index=0&id=6f1ceaef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports